import ElectiveDisciplinesPage from "./ElectiveDisciplinesPage";

export default ElectiveDisciplinesPage;